import { TopicType } from '@api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { postTopic } from '@terminal/services/topics/topics-service';

import { QUERY_KEY_FOLLOWED_TOPICS } from './useFollowedTopics';

type FollowTopicVariables = {
  type: TopicType;
  code: string;
};

export const useFollowTopic = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ type, code }: FollowTopicVariables) => postTopic(type, code),
    onSuccess: (data, { type }) => {
      queryClient.setQueryData([QUERY_KEY_FOLLOWED_TOPICS, type], data);
    },
    onSettled: (_data, _error, { type }) => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEY_FOLLOWED_TOPICS, type],
      });
    },
  });
};
